export default {
  technicalError: "ტექნიკური შეფერხება",

  logout: "სისტემიდან გამოსვლა",
  incorrectUsernameAndPassword: "არასწორი მომხმარებელი ან პაროლი",
  lockUsername: "მომხმარებელი დაბლოკილია ადმინისტრაციის მიერ",
  tooManyAttempts: "მომხმარებელი დაბლოკილია ბევრი მცდელობების გამო",
  noUser: "მომხმარებელი არ არსებობს",
  Ok: 0,

  CarCheckOutOfLimit: "ლიმიტი ამოწურულია",
  CarCheckNotFound: "პოლისი ვერ მოიძებნა",
  CarCheckLimitNotFound: "სერვისი არ არის გააქტიურებული",
  CarCheckNotAllowed: "თქვენ არ გაქვთ უფლება",
  CarCheckUnknownError: "ტექნიკური შეფერხება",
  CarCheckAprooved: "კოდი მიღებულია",
  CarCheckOtpExired: "კოდი ვადაგასულია",
  CarCheckOtpInvalid: "კოდი არასწორია",
  CarCheckPolicyNotActive: "პოლისი არ არის აქტიური",
  CarCheckPolicyInActiveInAreas:
    "სერვისი მიუწვდომელია პოლისზე არსებული დავალიანების გამო",
  CarCheckNotValidPolicy: "დაზღვეულს არ ეკუთვნის უფასო სერვისები",
  CarCheckTooOldCar: "დაზღვეულს არ ეკუთვნის უფასო სერვისები",
  CarCheckPhoneNumberNotFound:
    "დაზღვეულზე არ არის მითითეთებული მობილურის ნომერი, გთხოვთ დაუკავშირდეთ ადმინისტრაციას",

  CarCheckFillAllFields: "შეავსეთ ყველა ველი",

  CarWashAddNoName: "შეიყვანეთ კომპანიის დასახელება",
  CarWashAddNoTaxCode: "შეიყვანეთ საიდენტიფიკაციო კოდი",
  CarWashAddNoPhoneNumber: "შეიყვანეთ საკონტაქტო ტელეფონის ნომერი",
  CarWashAddNoContactPerson: "შეიყვანეთ საკონტაქტო პირი",

  CarWashUpdateOk: "მონაცემები განახლებულია",
  CarWashUpdateCarWashNotFound: "კომპანია ვერ მოიძებნა",

  CawWashLimitUpdateNoProduct: "აირჩიეთ პროდუქტი",
  CawWashLimitUpdateNoService: "აირჩიეთ სერვისი",
  CawWashLimitUpdateNoLimit: "შეიყვანეთ ლიმიტი",
  CarWashLimitUpdateMainIsExists:
    "არსებული პროდუქტი ძირითადი სტატუსით უკვე არსებობს",

  CawWashAddUserNoRole: "აირჩიეთ როლი",
  CawWashAddUserNoUserName: "შეიყვანეთ მომხმარებლის სახელი",
  CawWashAddUserCorrectUserName:
    "შეიყვანეთ ვალიდური მომხმარებლის სახელი, დასაშვებია მხოლოდ ლათინური სიმბოლოები და ციფრები",
};
